import type { SearchParams } from '@/server/searchParams.ts';
import { URLParameters } from '@/app/common/urlParameters.ts';

// What the dynamic filters describe: the search itself, not the selection made within it. Sorting,
// paging, the map area and the filters are all deliberately absent, so none of them invalidates the
// bar and only a genuinely different search does.
const SEARCH_IDENTITY_PARAMS = [
  URLParameters.SEARCH_MODE,
  URLParameters.ORIGIN,
  URLParameters.DESTINATION,
  URLParameters.DATE_FROM,
  URLParameters.DATE_TO,
  URLParameters.TRIP_DATES,
  URLParameters.ADULTS,
  URLParameters.AGES,
];

export const dynamicFiltersSearchKey = (searchParams: SearchParams): string =>
  SEARCH_IDENTITY_PARAMS.map((name) => searchParams[name] || '').join('|');
